export default "__VITE_ASSET__COinXo6A__"